export default [
  {
    path: "/hazardous",
    name: "hazardous",
    meta: {
      title: "t_qylb",
      scroll: true,
    },
    component: () => import("../../views/layout.vue"),
    redirect: "/hazardous/index",
    children: [
      {
        path: "/hazardous/index",
        name: "hazardousHome",
        meta: {
          title: "t_qylb",
          scroll: true,
        },
        component: () => import("../../views/hazardous/home.vue"),
      },
      {
        path: "/hazardous/monitor",
        name: "hazardousMonitor",
        meta: {
          title: "t_kr92",
          scroll: true,
          permission: "",
        },
        component: () => import("../../views/hazardous/monitor.vue"),
      },
      {
        path: "/hazardous/collect",
        name: "hazardousCollect",
        meta: {
          title: "t_de8uz9",
          scroll: true,
          permission: "hw:collect",
        },
        component: () => import("../../views/hazardous/collect/index.vue"),
        redirect: "/hazardous/collect/record",
        children: [
          {
            path: "/hazardous/collect/record",
            name: "hazardousCollectRecord",
            meta: {
              title: "t_debh85",
              scroll: true,
              permission: "hw:collect:detail",
              keepAlive: true,
            },
            component: () => import("../../views/hazardous/collect/record.vue"),
          },
          {
            path: "/hazardous/collect/recordDetail",
            name: "hazardousRecordDetaill",
            meta: {
              title: "t_inp8ic",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/collect/recordDetail.vue"),
          },
          {
            path: "/hazardous/collect/flowRecord",
            name: "hazardousFlowRecord",
            meta: {
              title: "t_ee40r7",
              scroll: true,
              permission: "hw:flow",
              keepAlive: true
            },
            component: () =>
              import("../../views/hazardous/collect/flowRecord.vue"),
          },
          {
            path: "/hazardous/collect/flowRecordDetail",
            name: "hazardousFlowRecordDetail",
            meta: {
              title: "t_kay7gu",
              scroll: true
            },
            component: () =>
              import("../../views/hazardous/collect/flowRecordDetail.vue"),
          },
          {
            path: "/hazardous/collect/stock",
            name: "hazardousCollectStock",
            meta: {
              title: "t_de3s6t",
              scroll: true,
              permission: "hw:collect:stock",
            },
            component: () => import("../../views/hazardous/collect/stock.vue"),
          },
        ],
      },
      {
        path: "/hazardous/waste",
        name: "hazardousWaste",
        meta: {
          title: "t_b6ejwb",
          scroll: true,
          permission: "hw",
        },
        component: () => import("../../views/hazardous/waste/index.vue"),
        redirect: "/hazardous/waste/delivery",
        children: [
          {
            path: "/hazardous/waste/delivery",
            name: "hazardousDelivery",
            meta: {
              title: "t_ibpjc4",
              scroll: true,
              permission: "hw:delivery",
              keepAlive: true,
            },
            component: () => import("../../views/hazardous/waste/delivery.vue"),
          },
          {
            path: "/hazardous/waste/waitDelivery",
            name: "hazardousWaitDelivery",
            meta: {
              title: "t_ce8j3j",
              scroll: true,
              permission: "hw:waitDelivery",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/waste/waitDelivery.vue"),
          },
          {
            path: "/hazardous/waste/deliveryDetail",
            name: "hazardousDeliveryDetail",
            meta: {
              title: "t_ibpjc4",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/deliveryDetail.vue"),
          },
          {
            path: "/hazardous/waste/storageIn",
            name: "hazardousStorageIn",
            meta: {
              title: "t_i2k6jy",
              scroll: true,
              permission: "hw:storageIn",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageIn.vue"),
          },
          {
            path: "/hazardous/waste/storageInDetail",
            name: "hazardousStorageInDetail",
            meta: {
              title: "t_i2k6jy",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageInDetail.vue"),
          },
          {
            path: "/hazardous/waste/storageOut",
            name: "hazardousStorageOut",
            meta: {
              title: "t_hzx1ib",
              scroll: true,
              permission: "hw:storageOut",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageOut.vue"),
          },
          {
            path: "/hazardous/waste/storageOutDetail",
            name: "hazardousStorageOutDetail",
            meta: {
              title: "t_hzx1ib",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageOutDetail.vue"),
          },
          {
            path: "/hazardous/waste/success",
            name: "hazardousSuccess",
            meta: {
              title: "t_d1spvi",
              scroll: true,
            },
            component: () => import("../../views/hazardous/waste/success.vue"),
          },
          {
            path: "/hazardous/waste/dispose",
            name: "hazardousDispose",
            meta: {
              title: "t_hqlopt",
              scroll: true,
              permission: "hw:storageUse",
              keepAlive: true,
            },
            component: () => import("../../views/hazardous/waste/dispose.vue"),
          },
          {
            path: "/hazardous/waste/disposeDetail",
            name: "hazardousDisposeDetail",
            meta: {
              title: "t_hqlopt",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/disposeDetail.vue"),
          },
          {
            path: "/hazardous/waste/plan",
            name: "hazardousPlan",
            meta: {
              title: "t_g30nh2",
              scroll: true,
              permission: "hw:plan",
              keepAlive: true,
            },
            component: () => import("../../views/hazardous/waste/plan.vue"),
          },
          {
            path: "/hazardous/waste/storageCorrect",
            name: "hazardousStorageCorrect",
            meta: {
              title: "t_d0vlez",
              scroll: true,
              permission: "hw:storageCorrect",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageCorrect.vue"),
          },
          {
            path: "/hazardous/waste/storageCorrectDetail",
            name: "hazardousStorageCorrectDetail",
            meta: {
              title: "t_d0vlezDetail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/storageCorrectDetail.vue"),
          },
          {
            path: "/hazardous/waste/planDetailList",
            name: "hazardousPlanDetailList",
            meta: {
              title: "t_hyfiwy",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/planDetailList.vue"),
          },
          {
            path: "/hazardous/waste/planDetail",
            name: "hazardousPlanDetail",
            meta: {
              title: "t_hyfiwy",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/planDetail.vue"),
          },
          {
            path: "/hazardous/waste/planWasteDetail",
            name: "hazardousPlanWasteDetail",
            meta: {
              title: "t_cd7115",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/planWasteDetail.vue"),
          },
          {
            path: "/hazardous/waste/planSuccess",
            name: "hazardousPlanSuccess",
            meta: {
              title: "t_cx7dr7",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/waste/planSuccess.vue"),
          },
          {
            path: "/hazardous/waste/backStore",
            name: "hazardousBackStore",
            meta: {
              title: "t_returnToStorage",
              scroll: true,
              permission: "hw:scanBack",
            },
            component: () =>
              import("../../views/hazardous/waste/backStore.vue"),
          },
          {
            path: "/hazardous/waste/virtualLabel",
            name: "hazardousVirtualLabel",
            meta: {
              title: "t_virtualLabel",
              scroll: true,
              permission: "hw:virtualDelivery",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/waste/virtualLabel.vue"),
          },
        ],
      },
      {
        path: "/hazardous/analysis",
        name: "hazardousAnalysis",
        meta: {
          title: "t_d7k0js",
          scroll: true,
          permission: "hw:summary",
        },
        component: () => import("../../views/hazardous/analysis/index.vue"),
        redirect: "/hazardous/analysis/monthReport",
        children: [
          {
            path: "/hazardous/analysis/monthReport",
            name: "hazardousMonthReport",
            meta: {
              title: "t_i2e5",
              scroll: true,
              permission: "hw:summary:monthReport",
            },
            component: () =>
              import("../../views/hazardous/analysis/monthReport.vue"),
          },
          {
            path: "/hazardous/analysis/monthDetailList",
            name: "hazardousMonthDetailList",
            meta: {
              title: "t_i2e5Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/monthDetailList.vue"),
          },
          {
            path: "/hazardous/analysis/monthDetail",
            name: "hazardousMonthDetail",
            meta: {
              title: "t_i2e5Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/monthDetail.vue"),
          },
          {
            path: "/hazardous/analysis/quarterReport",
            name: "hazardousQuarterReport",
            meta: {
              title: "t_g336",
              scroll: true,
              permission: "hw:summary:quarterReport",
            },
            component: () =>
              import("../../views/hazardous/analysis/quarterReport.vue"),
          },
          {
            path: "/hazardous/analysis/quarterDetailList",
            name: "hazardousQuarterDetailList",
            meta: {
              title: "t_g336Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/quarterDetailList.vue"),
          },
          {
            path: "/hazardous/analysis/quarterDetail",
            name: "hazardousQuarterDetail",
            meta: {
              title: "t_g336Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/quarterDetail.vue"),
          },
          {
            path: "/hazardous/analysis/yearReport",
            name: "hazardousYearReport",
            meta: {
              title: "t_glv5",
              scroll: true,
              permission: "hw:summary:yearReport",
            },
            component: () =>
              import("../../views/hazardous/analysis/yearReport.vue"),
          },
          {
            path: "/hazardous/analysis/yearDetailList",
            name: "hazardousYearDetailList",
            meta: {
              title: "t_glv5Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/yearDetailList.vue"),
          },
          {
            path: "/hazardous/analysis/yearDetail",
            name: "hazardousYearDetail",
            meta: {
              title: "t_glv5Detail",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/analysis/yearDetail.vue"),
          },
          {
            path: "/hazardous/analysis/dashboard",
            name: "hazardousAnalysisDashboard",
            meta: {
              title: "t_d7l48s",
              scroll: true,
              permission: "hw:summary:dashboard",
            },
            component: () =>
              import("../../views/hazardous/analysis/dashboard.vue"),
          },
        ],
      },
      {
        path: "/hazardous/setting",
        name: "hazardousSetting",
        meta: {
          title: "t_gar1ro",
          scroll: true,
          permission: "setting",
        },
        component: () => import("../../views/hazardous/setting/index.vue"),
        redirect: "/hazardous/setting/facility",
        children: [
          {
            path: "/hazardous/setting/facility",
            name: "hazardousFacility",
            meta: {
              title: "t_vg50rs",
              scroll: true,
              permission: "setting:deliveryFacility",
            },
            component: () =>
              import("../../views/hazardous/setting/facility.vue"),
          },
          {
            path: "/hazardous/setting/useFacility",
            name: "hazardousUseFacility",
            meta: {
              title: "t_tt22yx",
              scroll: true,
              permission: "setting:useFacility",
            },
            component: () =>
              import("../../views/hazardous/setting/useFacility.vue"),
          },
          {
            path: "/hazardous/setting/storageFacility",
            name: "hazardousStorageFacility",
            meta: {
              title: "t_dwck2y",
              scroll: true,
              permission: "setting:storageFacility",
            },
            component: () =>
              import("../../views/hazardous/setting/storageFacility.vue"),
          },
          {
            path: "/hazardous/setting/receive",
            name: "hazardousReceive",
            meta: {
              title: "t_h0dy46",
              scroll: true,
              permission: "setting:transfer",
            },
            component: () =>
              import("../../views/hazardous/setting/receive.vue"),
          },
        ],
      },
      {
        path: "/hazardous/settle",
        name: "hazardousSettle",
        meta: {
          title: "t_gl4wvs",
          scroll: true,
          permission: "hw:settle",
        },
        component: () => import("../../views/hazardous/settle/index.vue"),
        redirect: "/hazardous/settle/wait",
        children: [
          {
            path: "/hazardous/settle/wait",
            name: "hazardousSettleWait",
            meta: {
              title: "t_em0oo",
              scroll: true,
              permission: "hw:settle:wait",
              keepAlive: true
            },
            component: () => import("../../views/hazardous/settle/wait.vue"),
          },
          {
            path: "/hazardous/settle/complete",
            name: "hazardousSettleComplete",
            meta: {
              title: "t_j97gi",
              scroll: true,
              permission: "hw:settle:complete",
              keepAlive: true
            },
            component: () =>
              import("../../views/hazardous/settle/complete.vue"),
          },
          {
            path: "/hazardous/settle/completeDetail",
            name: "hazardousSettleCompleteDetail",
            meta: {
              title: "t_gto1ep",
              scroll: true,
              permission: ""
            },
            component: () =>
              import("../../views/hazardous/settle/completeDetail.vue"),
          },
          {
            path: "/hazardous/settle/success",
            name: "hazardousSettleSuccess",
            meta: {
              title: "t_em0oo",
              scroll: true,
              permission: "",
            },
            component: () => import("../../views/hazardous/settle/success.vue"),
          },
        ],
      },
      {
        path: "/hazardous/transfer",
        name: "hazardousTransfer",
        meta: {
          title: "t_iloxjo",
          scroll: true,
          permission: "hw:transfer",
        },
        component: () => import("../../views/hazardous/transfer/index.vue"),
        redirect: "/hazardous/transfer/waitList",
        children: [
          {
            path: "/hazardous/transfer/waitList",
            name: "hazardousTransferWaitList",
            meta: {
              title: "t_eoqj8",
              scroll: true,
              permission: "hw:transfer:wait",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/transfer/waitList.vue"),
          },
          {
            path: "/hazardous/transfer/deliveryDetail",
            name: "hazardousTransferDeliveryDetail",
            meta: {
              title: "t_ibpjc4",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/transfer/deliveryDetail.vue"),
          },
          {
            path: "/hazardous/transfer/transferRecord",
            name: "hazardousTransferTransferRecord",
            meta: {
              title: "t_ilpjv4",
              scroll: true,
              permission: "hw:transfer:record",
              keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/transfer/transferRecord.vue"),
          },
          {
            path: "/hazardous/transfer/recordDetail",
            name: "hazardousRecordDetail",
            meta: {
              title: "t_ilpjv4Detail",
              scroll: true,
              permission: "",
              // keepAlive: true,
            },
            component: () =>
              import("../../views/hazardous/transfer/recordDetail.vue"),
          },
          {
            path: "/hazardous/transfer/success",
            name: "hazardousTransferSuccess",
            meta: {
              title: "t_qjg1ng",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/hazardous/transfer/success.vue"),
          },
          {
            path: "/hazardous/transfer/transferChange",
            name: "hazardousTransferTransferChange",
            meta: {
              title: "t_ordModConf",
              scroll: true,
              permission: "hw:transfer:change",
            },
            component: () =>
              import("../../views/hazardous/transfer/transferChange.vue"),
          },
          {
            path: "/hazardous/transfer/transferChangeDetail",
            name: "transfer/transferChangeDetail",
            meta: {
              title: "t_ordModConf",
              scroll: true
            },
            component: () =>
              import("../../views/hazardous/transfer/transferChangeDetail.vue"),
          },
          {
            path: "/hazardous/transfer/transferBack",
            name: "hazardousTransferTransferBack",
            meta: {
              title: "退单退货",
              scroll: true,
              permission: "hw:transfer:back",
            },
            component: () =>
              import("../../views/hazardous/transfer/transferBack.vue"),
          },
          {
            path: "/hazardous/transfer/transferBackDetail",
            name: "transfer/transferBackDetail",
            meta: {
              title: "退单退货",
              scroll: true,
            },
            component: () =>
              import("../../views/hazardous/transfer/transferBackDetail.vue"),
          },
        ],
      },
      {
        path: "/hazardous/riskAlert",
        name: "hazardousRiskAlert",
        meta: {
          title: "t_jwlm9p",
          scroll: true,
          permission: "hw:riskAlert",
        },
        component: () => import("../../views/hazardous/riskAlert/index.vue"),
        redirect: "/hazardous/riskAlert/list",
        children: [
          {
            path: "/hazardous/riskAlert/list",
            name: "hazardousRiskAlertList",
            meta: {
              title: "t_jwlm9p",
              scroll: true,
            },
            component: () => import("../../views/hazardous/riskAlert/list.vue"),
          },
        ],
      },
    ],
  },
];
